module.exports = __webpack_public_path__ + "static/media/TelegramIcon.1ffacdc2.svg";